import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/Auth/AuthContext";
import api from "../services/api";

const AccessControlSwitch = () => {
  const { user } = useContext(AuthContext);
  const [allowUsers, setAllowUsers] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const isAdmin = user?.profile === "admin";

  useEffect(() => {
    if (!isAdmin) return;

    const fetchAccessControl = async () => {
      setLoading(true);
      try {
        const res = await api.get("/access-control");
        setAllowUsers(res.data.allowUsers);
      } catch {
        setError("No se pudo obtener el estado de acceso");
      } finally {
        setLoading(false);
      }
    };

    fetchAccessControl();
  }, [isAdmin]);

  const handleChange = async (e) => {
    const value = e.target.checked;
    setLoading(true);
    try {
      await api.post("/access-control", { allowUsers: value });
      setAllowUsers(value);
    } catch {
      setError("No se pudo actualizar el estado");
    } finally {
      setLoading(false);
    }
  };

  if (!isAdmin) return null;

  return (
    <div style={{ margin: "20px 0" }}>
      <label>
        <input
          type="checkbox"
          checked={allowUsers}
          onChange={handleChange}
          disabled={loading}
        />
        Permitir acceso a usuarios comunes
      </label>
      {loading && <span style={{ marginLeft: 10 }}>Cargando...</span>}
      {error && <div style={{ color: "red" }}>{error}</div>}
    </div>
  );
};

export default AccessControlSwitch;
